import {MetaTags} from '@frontend/components/MetaTags'
import {trans} from '@frontend/helpers'
import {useAppInitialization} from '@frontend/hooks/useAppInitialization'
import {Footer} from '@frontend/modules/layout/footer/Footer'
import {Header} from '@frontend/modules/layout/header/Header'
import {MiniChat} from '@frontend/modules/private/chats/components/MiniChat'
import {LoginModal} from '@frontend/modules/public/auth/components/LoginModal'
import {
    useAppRootStore,
    useLocaleStore,
} from '@frontend/stores'
import {useRef} from 'react'
import {BrowserRouter} from 'react-router-dom'
import {CSSTransition} from 'react-transition-group'
import {AppConfig} from '../../AppConfig'
import {AppRoutes} from '../../routes/AppRoutes'

/*
 * Корневой компонент.
 * Сначала загружает минимальный набор необходимых данных для отображения страниц.
 * Когда всё готово - монтирует роутер.
 * Дополнительно: Контроль Polling запросов и WebSocket соединения.
 */
export function Root() {

    const loading = useAppRootStore(
        state => state.loading
    )
    const appSection = useAppRootStore(
        state => state.section
    )
    const translationsLoaded = useLocaleStore(
        state => state.translationsLoaded
    )
    // Принудительная перерисовка при обновлении строк в переводах.
    useLocaleStore(
        state => state.forceRerender
    )

    const transitionRef = useRef<HTMLDivElement>(null)

    // Запускаем настройку и загрузку данных (1 раз при монтировании компонента).
    useAppInitialization(10)

    return (
        <BrowserRouter basename={AppConfig.baseUrl}>
            <CSSTransition
                in={!loading}
                classNames="fade"
                timeout={500}
                appear
                mountOnEnter
                unmountOnExit
                nodeRef={transitionRef}
            >
                <div
                    ref={transitionRef}
                    className="flex-container-row full-width flex-fill fade-init"
                >
                    <div
                        className={appSection === 'private' ? 'private-page' : 'public-page'}
                    >
                        {translationsLoaded && (
                            <MetaTags
                                title={trans().common.meta_tags.defaultTitle}
                                description={null}
                            />
                        )}
                        <Header />
                        <AppRoutes />
                        <Footer />
                        <LoginModal />
                        <MiniChat />
                    </div>
                </div>
            </CSSTransition>
        </BrowserRouter>
    )
}
